<template>
  <div id="document-info">
    <div class="position-relative w-100">
      <div class="document-step">
        <step-navbar
          :step-active="stepActive"
          :formData="formData"
          :tab-list="['Document Detail', 'Confirm Document']"
        />
      </div>
      <div class="document-info-wrp">
        <div class="row">
          <div class="col-12">
            <div class="position-relative">
              <information
                :is-edit="!modeEditor"
                :document-id="documentId"
                @onNextStep="stepActive++"
                @onPreviousStep="stepActive--"
                @onGetDocumentId="onGetDocumentId"
                @onFormData="onFormData"
                @onSetFormData="onSetFormData"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StepNavbar from "../components/StepNavbar.vue";
import useDocumentInfo from "./hooks/useDocumentInfo";
import Information from "./components/Information.vue";
import { reactive } from "@vue/composition-api";

export default {
  components: { Information, StepNavbar },
  setup() {
    const {
      modeEditor,
      stepActive,
      documentId,
      onGetDocumentId,
      onNextStep,
      onPreviousStep,
      onFormData,
      formData,
      onSetFormData,
    } = useDocumentInfo();

    return {
      modeEditor,
      stepActive,
      documentId,
      onGetDocumentId,
      onNextStep,
      onPreviousStep,
      onFormData,
      formData,
      onSetFormData,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/override-styles/status.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/override-styles/progress-nav.css";
@import "~@/assets/css/pages/document/document-info.css";
</style>
